import { useEffect, useState } from "react";

import { LEGAL_DOCUMENT_TYPES, legalService, TLegalDocument } from "@/api/legal";
import { LegalDocumentView } from "@/components/legal/LegalDocumentView";
import { extractErrorMessage } from "@/utils/errorUtils";

export const CookiesPolicy = () => {
  const [document, setDocument] = useState<TLegalDocument | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    void (async () => {
      setIsLoading(true);
      const { data, error } = await legalService.getActiveDocument(LEGAL_DOCUMENT_TYPES.cookiesPolicy);
      if (data) {
        setDocument(data.data);
        setErrorMessage(null);
      } else {
        setDocument(null);
        setErrorMessage(
          error ? await extractErrorMessage(error) : "Cookies Policy is not available yet."
        );
      }
      setIsLoading(false);
    })();
  }, []);

  return (
    <LegalDocumentView
      document={document}
      isLoading={isLoading}
      errorMessage={errorMessage}
      pageTitle="Cookies Policy"
    />
  );
};
